import { Settings } from 'luxon';
import { ZONE } from '../constants';

Settings.defaultZone = ZONE;
